import { TenantPackageConfig } from '~/tenants/common/registry';
import { McmOrderContext } from '~/tenants/mcm/model/McmOrder';
import McmPhotoConfig from '~/tenants/mcm/performable/photo/McmPhotoConfig';
import McmZillowConfig from '~/tenants/mcm/performable/zillow/McmZillowConfig';

const McmPackageCrossroadsBronze: TenantPackageConfig<McmOrderContext> = {
  id: 'cr_bronze',
  name: 'Crossroads Bronze',
  hideSavings: true,
  performables: [
    McmPhotoConfig,
    McmZillowConfig
  ],
  eligible: ({ buyer, parent }) => Boolean(buyer.metadata.crossroads || parent?.crossroads),
  description: 'Up to 30 Photos and Zillow 2D Floorplan + Zillow 3D',
};

export default McmPackageCrossroadsBronze;
